import {ReactNode, useEffect, useState} from "react";
import {createPortal} from "react-dom";

import {tdaPortalId} from "../constants/tda_portal_id";

interface IProps {
    children: ReactNode;
}

export function TdaPortal(props: IProps) {
    const {children} = props;
    const [domNode, setDomNode] = useState<HTMLElement | null>(null);

    useEffect(() => {
        const domNode = document.getElementById(tdaPortalId);

        if (domNode) {
            setDomNode(domNode);
        }
    }, []);

    if (!domNode) {
        return null;
    }

    return <div>{createPortal(<>{children}</>, domNode)}</div>;
}
